// extracted by mini-css-extract-plugin
export var copyIcon = "_z3-2";
export var discountCard = "_z3-0";
export var discountCode = "_z3-3";
export var discountContent = "_z3-1";
export var loadingCard = "_z3-4";